import React, { ReactElement, useEffect } from "react";
import { Helmet } from "react-helmet";
import DOMPurify from "dompurify";

const { host } = window.location;

export const environment = {
  hosts: {
    default: {
      host: "default",
      maisonMereUrl:
        "https://www.tutelaire.fr/nos-offres/paxivie/accidents-de-la-vie",
      title: "Tutelaire - Paxivie",
      gtmId: process.env.VITE_TUTELAIRE_GTM_ID,
      docDIPA:
        "https://lya-public.s3.eu-west-3.amazonaws.com/tutelaire/DIPA_paxivie.pdf",
      docReglement:
        "https://lya-public.s3.eu-west-3.amazonaws.com/tutelaire/REGLEMENT_paxivie.pdf",
      docStatut:
        "https://lya-public.s3.eu-west-3.amazonaws.com/tutelaire/STATUT_paxivie.pdf",
      docAssistance:
        "https://lya-public.s3.eu-west-3.amazonaws.com/tutelaire/NOTICE-ASSISTANCE_paxivie.pdf",
    },
  },

  get is(): Record<keyof typeof this.hosts, boolean> {
    return Object.keys(this.hosts).reduce((acc, key) => {
      return { ...acc, [key]: key === this.name };
    }, {} as Record<keyof typeof this.hosts, boolean>);
  },

  get name(): keyof typeof this.hosts {
    return Object.entries(this.hosts).reduce<keyof typeof this.hosts>(
      (acc, [key, value]) => {
        return host === value.host ? (key as keyof typeof this.hosts) : acc;
      },
      "default"
    );
  },

  get current(): typeof this.hosts.default {
    return this.hosts[this.name];
  },
};

type AppProps = {
  children?: React.ReactNode;
};

export function MarqueBlanche({ children }: AppProps): ReactElement {
  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty("--accent-h", "39");
    root.style.setProperty("--accent-s", "100%");
    root.style.setProperty("--accent-l", "40%");
    root.style.setProperty("--accent-secondary-h", "65");
    root.style.setProperty("--accent-secondary-s", "70%");
    root.style.setProperty("--accent-secondary-l", "47%");
  }, []);

  return (
    <>
      <Helmet>
        <title>{environment.current.title}</title>
        {environment.is.default && (
          <link rel="icon" href="/logo-min-tutelaire.svg" />
        )}
        {environment.current.gtmId && (
          <script
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(`
                  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                  })(window,document,'script','dataLayer','${environment.current.gtmId}');
                `),
            }}
          />
        )}
      </Helmet>
      {children}
    </>
  );
}
